export const newPassword = {
  title: 'Passwort zurücksetzen',
  resetFailed: 'Passwort konnte nicht zurückgesetzt werden.',
  resetButton: 'Passwort zurücksetzen',
}
